import { unsetAuthData } from 'app/slice/authSlice';

import store from 'app/store';
import axios from 'axios';
import { VI_LANG } from 'constants/global';
import getMessage401 from 'helpers/error/getMessage401';
import getMessage403 from 'helpers/error/getMessage403';
import getMessageError from 'helpers/error/getMessageError';
import getSystem from 'helpers/getSystem';
import { loading } from 'helpers/loading/Loading';
import queryString from 'query-string';
import keycloak from '../keycloak';

const windowEnvConfig = window['runConfig'];
// Set up default config for http requests here
// Please have a look at here `https://github.com/axios/axios#request- config` for the full list of configs

const axiosClient = axios.create({
    baseURL: windowEnvConfig.REACT_APP_BASE_API_URL,
    headers: {
        'content-type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
    paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use(async (config) => {
    const local = localStorage.getItem('locale') || VI_LANG;

    const token = keycloak.authenticated ? keycloak.token : '';
    loading.runLoadingBlockUI();

    config.headers.lang = local;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers.system = getSystem();

    return config;
});

axiosClient.interceptors.response.use(
    (response) => {
        loading.stopRunLoading();
        if (response?.data) {
            return response.data;
        }
        loading.stopRunLoading();

        return response;
    },
    (error) => {
        // Handle errors
        loading.stopRunLoading();
        const local = localStorage.getItem('locale') || VI_LANG;

        const response = error.response;
        if (response && response.status === 401) {
            if (response?.data?.status === 401) {
                // if (response?.data?.type === 2) {
                //     store.dispatch(authData401({ message: response?.data?.message ?? error.message }));
                //     if (window.location.pathname !== routerMain.PAGE_401) {
                //         localStorage.setItem('historyUrl', window.location.pathname);
                //         window.location = routerMain.PAGE_401;
                //     }
                //     return;
                // }
                getMessage401(local, response?.data?.message ?? error.message);
                return;
            }
            store.dispatch(unsetAuthData());
            keycloak.logout();
            return;
        }
        if (response && response.status === 403) {
            getMessage403(local);
            return;
        }
        getMessageError(local, error.message);
        throw error;
    }
);

export default axiosClient;
